import { ButtonBase, Grid, Box } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";

const Header = ({ fulter, selected, handleClick, visible }) => {
  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile } = useContext(ScreenContext);
  return (
    <>
      <Grid
        container
        justifyContent="center"
        width="100%"
        pt={isMobile ? 1 : 0}
      >
        {fulter.map((doc) => {
          const isActive = selected?.name === doc.name;
          return (
            <Grid
              item
              key={doc.name}
              sx={{ m: 1 }}
              pt={!isMobile ? 5 : 0}
              pb={!isMobile ? 5 : 0}
            >
              <ButtonBase
                onClick={() => handleClick(doc)}
                sx={{
                  backgroundColor: isActive ? doc.color : "transparent",
                  border: !isActive && `1px solid #FFF`,
                  ...design.ButtonBase,
                }}
              >
                {doc.name}
              </ButtonBase>
            </Grid>
          );
        })}
      </Grid>
      <Box
        sx={{
          opacity: visible ? 1 : 0,
          ...design.Box,
        }}
      >
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <ImageLoader
            src={selected?.logo}
            alt={selected?.name}
            width={isMobile ? 107 : 214}
            height={isMobile ? 118 : 237}
          />
          <CustomText variant="subtitle1" color="#FFF" sx={design.Title}>
            {selected?.name}
          </CustomText>
        </Grid>
      </Box>
    </>
  );
};

export default Header;
const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 30,
      sm: 36,
      md: 50,
      lg: 50,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "2%",
    marginBottom: 5,
    textAlign: "center",
    width: "100%",
  },
  ButtonBase: {
    padding: "8px 18px",
    borderRadius: "10px",
    fontWeight: 600,
    transition: "0.3s",
    marginLeft: 1,
    marginRight: 1,
    color: "#fff",
    fontSize: {
      xs: 13,
      sm: 14,
      md: 15,
    },
  },
  Box: {
    position: "relative",
    width: "100%",
    transition: "opacity 0.5s ease",
  },
};
